<template>
    <div>
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <vxe-table
                ref="singleTable"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                resizable
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:2px"
        >
            <vxe-table-column show-overflow-tooltip field="paper_name" :title="$t('getapi[8079]')" width="80">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="wide" :title="$t('getapi[8080]')" width="100">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="height" :title="$t('getapi[8081]')" width="100">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="unit" :title="$t('getapi[916]')" width="120">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="create_person" :title="$t('getapi[3099]')" width="80">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="create_time" :title="$t('getapi[135]')" width="120">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="modify_person" :title="$t('getapi[733]')" width="80">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="modify_time" :title="$t('getapi[1210]')" width="120">
            </vxe-table-column>
            <vxe-table-column :title="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="edit(scope.row)" type="text" size="small">
                        {{$t('getapi[34]')}}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[656]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope.row)"
                    >
                        <el-button slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                    </el-popconfirm>
                </template>
            </vxe-table-column>
        </vxe-table>

        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[8077]')" width="30%">
            <!--<el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="110px"
                             label-position="left" size="small">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8079]')">
                                    <el-input v-model="dataDetail.paper_name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8080]')">
                                    <el-input v-model="dataDetail.wide" type="number" @mousewheel.native.prevent></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8081]')">
                                    <el-input v-model="dataDetail.height" type="number" @mousewheel.native.prevent></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[916]')">
                                    <el-input v-model="dataDetail.unit" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>

            </el-row>-->
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[8097]')}}</td>
                        <td><el-input v-model="dataDetail.paper_name"></el-input></td>
                        <td>{{$t('getapi[8080]')}}</td>
                        <td><el-input v-model="dataDetail.wide" type="number" @mousewheel.native.prevent></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8081]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.height" type="number" @mousewheel.native.prevent></el-input>
                        </td>
                        <td>{{$t('getapi[916]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.unit" :disabled="true"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'paperconfig',
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                DbTbNames: '',
                loading: false, // 主表加载状态
                tableHeight: Common.tableHeight3, // 主表高度
                dataDetail: {
                    num:'',
                    paper_name:'',
                    wide:'',
                    height:'',
                    unit:'',
                    create_time:'',
                    create_person:'',
                    modify_time:'',
                    modify_person:''
                },
                addoredit: 1,
                positionKey: '', //查询
                scrollTop:0,
            };
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView(),
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8077]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                that.$refs.SetBtn.SetButtonEnable('create,refresh,export');
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let data = {
                    PageIndex: 1,
                    PageSize: 1000,
                    SelectIndex: 1,
                    Ids: '',
                    Param: []
                };
                that.$http.urlpost('/Print/GetPrintPaperList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
                that.authority();
            },
            // 编辑
            edit(row) {
                let that = this
                that.addoredit = 2
                let datetime = Common.methods.getDatetime()
                that.isVisible = true
                that.dataDetail.num = row.num
                that.dataDetail.paper_name = row.paper_name
                that.dataDetail.wide = row.wide
                that.dataDetail.height = row.height
                that.dataDetail.unit = row.unit
                that.dataDetail.create_time = row.create_time
                that.dataDetail.create_person = row.create_person
                that.dataDetail.modify_time = datetime
                that.dataDetail.modify_person = that.user
            },
            // 新增
            add() {
                let that = this;
                that.addoredit = 1
                let datetime = Common.methods.getDatetime();
                that.isVisible = true
                that.dataDetail.num = ''
                that.dataDetail.paper_name = ''
                that.dataDetail.wide = ''
                that.dataDetail.height = ''
                that.dataDetail.unit = '毫米'
                that.dataDetail.create_time = datetime
                that.dataDetail.create_person = that.user
                that.dataDetail.modify_time = ''
                that.dataDetail.modify_person = ''
            },
            //保存
            save(){
                let that = this
                let parm = that.dataDetail
                if(that.addoredit == 1){
                    that.$http.urlpost('/Print/InsertPrintPaper', parm, function(res) {
                        if(res.Success == 1){
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.isVisible = false
                            that.getView()
                        }
                    });
                } else {
                    that.$http.urlpost('/Print/UpdatePrintPaper', parm, function(res) {
                        if(res.Success == 1){
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.isVisible = false
                            that.getView()
                        }
                    });
                }
            },
            del(row){
                let that = this
                let parm = row
                that.$http.urlpost('/Print/DeletePrintPaper', parm, function(res) {
                    if(res.Success == 1){
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            exps() {
                let that = this;
                let data = {
                    PageIndex: 1,
                    PageSize: 1000,
                    SelectIndex: 1,
                    Ids: '',
                    Param: [],
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[11867]')
                };
                that.$http.urlpost('/Print/ExportToExecl_PrintPaper', data, function(res) {
                    if(res.Success == 1){
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
